import * as React from "react"
import theme from "../theme"
import { Flex } from "rebass"

export const BookingButton = (props: any) => (
  <Flex
    alignItems="center"
    justifyContent="center"
    {...props}
    bg={theme.colors.black}
    style={{
      color: theme.colors.white,
      height: 50,
      cursor: "pointer",
      borderRadius: 0,
      minWidth: 200,
      fontSize: 18,
      fontWeight: 800,
      boxShadow: theme.shadows.smallPrimary
    }}
  />
)
